// extracted by mini-css-extract-plugin
export default {"like":"like__fed6b53b","theme_light":"theme_light__fed6b53b","active":"active__fed6b53b","theme_dark":"theme_dark__fed6b53b"};